<template>
  <div class="userinfo-water-mark" :style="waterMark" v-show="show"></div>
</template>
<script>
export default {
  name: "DsfUserInfoWaterMark",
  props: {
    text: {
      type: String,
      default: "",
    },
    waterMarkOptions: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      textString: "",
      observer: null,
      show: true,
    };
  },
  computed: {
    waterMark() {
      let opt = Object.assign({
        fontSize: 16,
        margin: [50, 50]
      }, this.waterMarkOptions);
      let scale = 4;
      opt.fontSize *= scale;
      opt.margin[0] *= scale;
      opt.margin[1] *= scale;
      let {width, height, base64} = dsf.safe.getWaterMark(this.textString, opt);
      return {
        "background-image": `url(${base64})`,
        "background-size": `${width / scale}px ${height / scale}px`
      };
    },
  },
  beforeCreate() {},
  created() {
    if (dsf.client.lessThenIE("11")) {
      this.show = false;
    }
  },
  beforeMount() {},
  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    createImage() {
      let str = "\n";
      if(this.text.split("\\n")?.length>1){
        // 说明是从script接口返回的（2024年2月21后，后端将不会转译配置的特殊字符。那么script接口会把实际配置的\n返回成\\n）
        str = "\\n";
      }
      let arr = this.text.split(str);
      arr = _.map(arr, it => {
        return this.$replace(it);
      });
      this.textString = arr.join("\n");
    },
  },
  watch: {
    text: {
      handler(v) {
        this.createImage();
      },
      immediate: true,
    },
  },
};
</script>
